import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getThemeFromProfile } from '../styles/theme';

/**
 * Custom hook to get the current theme based on store profile
 * @returns {Theme} Current theme object with colors and helpers
 */
export const useTheme = () => {
  const { profile } = useSelector((state) => state.profile);
  
  const theme = useMemo(() => {
    return getThemeFromProfile(profile);
  }, [profile]);
  
  return theme;
};

export default useTheme;

